import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconBrowser = createIcon({
  displayName: 'IconBrowser',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 4H22V6H4V18H20V8H22V20H2V4ZM6 8H18V10H6V8Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
